import React from 'react'
import './content.scss'

function EmeraldRunProfitablySection() {
  const hwhyData = [
    {
      title: 'Priced for your profit',
      description: 'Every last item you need. Every last dime maximized.',
    },
    {
      title: 'The Future of Innovation',
      description: 'Experience our tech-driven approach, AI, and custom software solutions.',
    },
    {
      title: 'Fast fulfillment your way',
      description:
        'FASTEST delivery in the industry using our own fleet and partnering with all major delivery carriers.',
    },
    {
      title: 'Our data, your power',
      description:
        'We can help you with automatic reports and alerts to help you better manage your supplies and orders.',
    },
  ]

  const RunProfitablyBox = ({ data }) => {
    return (
      <div className="hwhy__box">
        <h4 className="hwhy__box-title">{data.title}</h4>
        <p className="hwhy__box-desc">{data.description}</p>
      </div>
    )
  }

  return (
    <div className="hwhy">
      <div className="container">
        <h2 className="hwhy__title">How we help you Run profitably™</h2>
      </div>
      <div className="hwhy__block">
        {hwhyData.map((data, index) => (
          <RunProfitablyBox key={index} data={data} />
        ))}
      </div>
    </div>
  )
}

export default EmeraldRunProfitablySection
